import { defaultApi } from '../apis';

export const fetchSystemFolderId = async (): Promise<string> => {
  const response = await defaultApi.obtainSystemFolder();
  return response.data.folder_id;
};
